import styled from "styled-components";
import * as PropTypes from "prop-types";
// import { styling } from "../styling";

export default function Arrow({ disabled, left, up, down, color, style }) {
  let colorOverride = "black";
  if (color) {
    colorOverride = color;
  }

  return (
    <StyledSvg
      left={left}
      down={down}
      up={up}
      width="100%"
      height="100%"
      // viewBox="0 0 567 567"
      viewBox="0 0 21.36 11.42"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        fill: "none",
        stroke: colorOverride,
        strokeLinejoin: "round",
        strokeWidth: "1.42px",
        strokeLinecap: "round",
        opacity: disabled ? 0.4 : 1,
        ...style,
      }}
    >
      <polyline points="0.71 0.71 10.71 10.71 20.65 0.77" />
    </StyledSvg>
  );
}

const StyledSvg = styled.svg`
  transform: rotate(-90deg);
  ${({ left }) => left && "transform: rotate(90deg);"};
  ${({ up }) => up && "transform: rotate(-180deg);"};
  ${({ down }) => down && "transform: rotate(0deg);"};
`;

Arrow.propTypes = {
  disabled: PropTypes.bool,
  left: PropTypes.bool,
  up: PropTypes.bool,
  down: PropTypes.bool,
  color: PropTypes.string,
  style: PropTypes.object,
};

Arrow.defaultProps = {
  style: {},
};
